module.exports = __webpack_public_path__ + "img/logo-vkusniy-kebab.2f55b69f.png";